import React from 'react';
import { Switch, Route, BrowserRouter as Router } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';

import NotFoundPage from './containers/NotFoundPage';
import MainLayout from './containers/MainLayout';
import HomePage from './containers/HomePage';
import AppRoute from './components/AppRoute';
import ScrollToTop from './components/ScrollToTop';
import CanjeValeDigital from './containers/CanjeValeDigital';
import CanjePrestamoConfirmar from './containers/CanjePrestamoConfirmar';
import ConfirmarSolicitudCambio from './containers/ConfirmarSolicitudCambio';

const theme = createTheme({
  typography: {
    fontFamily: ['Avenir', 'Helvetica Neue', 'Arial'].join(','),
    useNextVariants: true,
  },
  palette: {
    primary: {
      main: '#994878',
    },
    secondary: {
      main: '#E3F1DF',
    },
    success: {
      main: '#4caf50',
    },
    error: {
      main: '#f44336',
    },
    info: {
      main: '#2196f3',
    },
    warning: {
      main: '#ff9800',
    },
  },
});

function App() {
  return (
    <MuiThemeProvider theme={theme}>
      <div>
        <Helmet titleTemplate="Conmigo Vales - %s" defaultTitle="Conmigo Vales">
          <meta name="description" content="Conmigo Vales" />
        </Helmet>
        <Router>
          <>
            <ScrollToTop />
            <Switch>
              <AppRoute
                exact
                path="/"
                layout={MainLayout}
                component={HomePage}
              />
              <Route
                exact
                path="/canje-vale/:token"
                component={CanjeValeDigital}
              />
              <Route
                exact
                path="/confirmar-prestamo/:token"
                component={CanjePrestamoConfirmar}
              />
              <Route
                exact
                path="/solicitud-cambio/:token"
                component={ConfirmarSolicitudCambio}
              />
              <Route component={NotFoundPage} />
            </Switch>
          </>
        </Router>
      </div>
    </MuiThemeProvider>
  );
}

export default App;
